import { useCallback } from 'react';
import { useGetAddonsList } from '../../api/addons';

export const useFilterAddonsTitleByValue: (addonIds: string[]) => { value: string; title: string }[] = (addonIds) => {
    const { data: { addons } = { addons: [] } } = useGetAddonsList({});

    const getTitle = useCallback((id: string) => addons.find((addon) => addon.id === id)?.title ?? id, [addons]);

    return addonIds.map((addonId) => {
        return { value: addonId, title: getTitle(addonId) };
    });
};
